import useNotificationToasts from "./useNotificationToasts";

const configuration = {
  kind: "BOOKING_UPLOADED_PAYMENT_POSTED", prefix: "uploaded-payment-posted",
  isEnabled: () => true,
  eligible: row => typeof row.receipt_path === "string" && !!row.receipt_path,
  title: row => `Payment approved and posted · ${row.booking_ref || row.booking_id}`,
  description: row => `Paid: ${row.currency} ${row.amount}. Receipt: ${row.receipt_no}`,
  actionLabel: "View receipt",
};

export default function usePaymentPostedNotificationToasts(resource, onView, onFailure) {
  useNotificationToasts(resource, onView, onFailure, configuration);
}
